@use '../../../style/mixins';
@use '../../../style/functions';

.button {
    all: unset;
    isolation: isolate;
    position: relative;

    @include mixins.is-flat-inset-clickable(
        $color: var(--limel-dock-item-text-color),
        $background-color: var(--dock-background-color)
    );
    @include mixins.visualize-keyboard-focus;

    box-sizing: border-box;
    display: flex;
    align-items: center;

    width: 100%;
    height: var(--dock-item-height);

    border-radius: functions.pxToRem(6);
    font-size: var(--limel-theme-default-font-size);
    padding: 0 0.5rem;
    min-width: var(--dock-item-height);

    &:hover {
        z-index: 1;
    }

    &.selected {
        color: var(--limel-dock-item-text-color--selected);
        background-color: var(
            --dock-item-background-color--selected,
            rgb(var(--contrast-200))
        );

        box-shadow: var(--button-shadow-inset);

        &:focus-visible {
            box-shadow:
                var(--button-shadow-inset), var(--shadow-depth-8-focused);
        }

        .icon {
            color: var(--limel-dock-item-text--selected);
        }
    }
}

limel-popover {
    // makes buttons that are wrapped in a popover become fullwidth
    display: grid;
    grid-template-columns: 100%;

    button[slot='trigger'][aria-expanded='true'] {
        box-shadow: var(--button-shadow-inset);
    }
}

.text {
    @include mixins.truncate-text();
    padding-left: 0.5rem;
    padding-right: 0.75rem;
}

.icon {
    flex-shrink: 0;
    width: calc(var(--dock-item-height) - 1rem);
    height: calc(var(--dock-item-height) - 1rem);
    color: var(--dock-item-icon-color, var(--limel-dock-item-text-color));
}

limel-badge {
    position: absolute;
    top: -0.125rem;
    right: -0.125rem;
}

// 👇 Below is a hidden and private hack
// only for usage in Lime CRM components.
// It enables our customers to override
// the default Home icon, using an external URL
// or an SVG code.
.icon {
    position: relative;

    &:before {
        text-align: center;
        pointer-events: none;
        position: absolute;
        inset: 0;
        background: {
            color: var(--dock-background-color, rgb(var(--contrast-100)));
            position: center;
            repeat: no-repeat;
            size: contain;
            image: var(--limel-custom-home-icon);
        }
        // Since `content` defaults to `undefined`
        // no pseudo element will be rendered, unless
        // the consumer defines something.
        content: var(--limel-custom-home-icon-enabler);

        .button.selected & {
            background-color: var(
                --dock-item-background-color--selected,
                rgb(var(--contrast-200))
            );
        }
    }
}
